// Match the displayed original frame to the last timestamp within the limit.
// ffprobe timestamps are stored to six decimal places; compare integer microseconds.
export function frameAtLimit(times,start,limit){
 const micros=value=>Math.round(Number(value)*1000000);
 const target=micros(times[start])+micros(limit);
 let lo=start,hi=times.length-1;
 while(lo<hi){const middle=Math.ceil((lo+hi)/2);if(micros(times[middle])<=target)lo=middle;else hi=middle-1;}
 return lo;
}
